const context = require.context('./', false, /face\.png$/)
const nameRegexp = /\.\/(.*)\.png/
const faces = {}
context.keys().forEach((key) => {
    const fileName = nameRegexp.exec(key)[1]
    faces[fileName] = context(key)
})

module.exports = Object.assign(module.exports, faces)
